import { render, staticRenderFns } from "./VacancyStates.vue?vue&type=template&id=06a348d2&"
import script from "./VacancyStates.vue?vue&type=script&lang=js&"
export * from "./VacancyStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports